/* eslint-disable react/require-default-props */
// List style radio buttons with capacity displaying follow-up stuff when radio button selected
import * as React from "react";
import { cx, css } from "@emotion/css";
import { FieldProps } from "formik";
import formGroupStyles from "../css/formgroup.module.css";
import { ComplicateOption } from "../support/InterfaceComplicateOption";
import { FieldNameEnum } from "../support/FieldNameEnum";

interface OtherProps {
  label: string | ((label: string | undefined) => React.ReactNode);
  labelText?: string;
  options: ComplicateOption[];
  onMount?: () => void;
}

type FieldRadioListProps = OtherProps & FieldProps;

const FieldRadioList = ({
  form: { values, setFieldValue },
  onMount,
  label,
  labelText,
  options
}: FieldRadioListProps): React.JSX.Element => {
  const fieldClasses = cx(formGroupStyles["form-group"]);

  React.useEffect(() => {
    // excute side effect onMount method
    if (onMount) onMount();
  }, [onMount]);

  return (
    <div className={fieldClasses}>
      {typeof label === "string" ? (
        <p className={formGroupStyles["label-like-text"]}>{label}</p>
      ) : (
        label(labelText)
      )}
      <div>
        <div
          className={css`
            margin: 20px;
          `}
        >
          {options.map(option => (
            <React.Fragment key={option.optionId}>
              <label htmlFor={option.optionId} id={`${option.optionId}Label`}>
                <input
                  type="radio"
                  id={option.optionId}
                  data-testid={option.optionId}
                  onChange={e => {
                    setFieldValue(
                      FieldNameEnum.transferInstructions,
                      option.optionId
                    );
                    option.onOptionSelected(e);
                  }}
                  checked={values.transferInstructions === option.optionId}
                />
                <p
                  className={css`
                    display: inline-block;
                  `}
                >
                  {option.optionDisplayText}
                </p>
              </label>
              {values.transferInstructions === option.optionId &&
                option.selectedRenderContent()}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FieldRadioList;
